import { exists } from "@@/utilities/exists";

const asArray = <T>(item: T | T[] | undefined | null): NonNullable<T>[] => {
    if (Array.isArray(item)) return item.flatMap(i => i).filter(exists);
    const c = !item ? [] : [item];
    return c;
};

export { asArray };
